import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { Tpl3plInboundResendPreviewDialogComponent } from './tpl3pl-inbound-resend-preview-dialog.component';

/** Inbound preview/send dialog — used from 3PL Inbound admin and Open Purchase Orders. */
@NgModule({
	imports: [
		CommonModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
	],
	declarations: [Tpl3plInboundResendPreviewDialogComponent],
	exports: [Tpl3plInboundResendPreviewDialogComponent],
})
export class Tpl3plInboundResendDialogModule {}
